import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
type FormSuccessProps = {
  title: string;
  children: React.ReactNode;
  onReset?: () => void;
  resetLabel?: string;
};
export function FormSuccess({
  title,
  children,
  onReset,
  resetLabel = 'Submit another'
}: FormSuccessProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1]
  }} className="border border-ink-line bg-ink-surface p-10 text-center" role="status" data-id="element-55" data-mp="377flcedduapl">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white text-ink" data-id="element-56" data-mp="3lvsl7mflcdpd">
        <CheckIcon className="h-7 w-7" data-id="element-57" data-mp="3pxnjsj650czg" />
      </span>
      <h2 className="mt-6 font-slab text-2xl font-bold uppercase tracking-[0.15em]" data-id="element-58" data-mp="3pwcfmi8s537t">{title}</h2>
      <div className="mx-auto mt-4 max-w-lg leading-relaxed text-ink-muted" data-id="element-59" data-mp="3uy1uya31c31p">{children}</div>
      {onReset && <button type="button" onClick={onReset} className="mt-8 font-slab text-xs font-bold uppercase tracking-[0.2em] underline underline-offset-8 hover:opacity-60" data-id="element-60" data-mp="3ntf24ihcwwa">
          {resetLabel}
        </button>}
    </motion.div>;
}